import { MerakiSwitchStatus } from '@app/shared/models/meraki/meraki-switch-status.model';
import { Fortigate } from '@app/shared/models/fortigate/fortigate.model';
import { Cradlepoint } from '@app/shared/models/cradlepoint/cradlepoint.model';
import { Mist } from '@app/shared/models/mist/mist.model';
import { Location } from '@app/shared/models/location.model';
import { NetworkState, NetworkStateEvaluation } from '@app/shared/utils/network-thresholds';

export class Restaurant {
    public merakis: MerakiSwitchStatus[];
    public fortigates: Fortigate[];
    public cradlepoints: Cradlepoint[];
    public mists: Mist[];
    public location: Location;
    public networkState?: NetworkState;
    public networkStateEvaluation?: NetworkStateEvaluation;
}